import { render } from "./ExpertSubTitleItem.vue?vue&type=template&id=8bf9335c&scoped=true&ts=true"
import script from "./ExpertSubTitleItem.vue?vue&type=script&lang=ts"
export * from "./ExpertSubTitleItem.vue?vue&type=script&lang=ts"

import "./ExpertSubTitleItem.vue?vue&type=style&index=0&id=8bf9335c&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf9335c"]])

export default __exports__